import {Order} from 'src/app/models'

export enum EAdminStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  INVITED = 'INVITED',
}

export interface IAdmin {
  id: string
  name: string
  employee_number?: string
  division: string
  status: keyof typeof EAdminStatus
  type: string
  organization: {
    id: string
    code: string
    name: string
  }
  company: {
    id: string
    code: string
    name: string
  }
  departments: {
    id: string
    code: string
    name: string
  }[]
  is_pic?: boolean
}

export interface IAdminDetail {
  name: string
  first_name: string
  last_name?: string
  employee_number?: string
  email: string
  mobile_number: string
  status: keyof typeof EAdminStatus
  last_activity: string
  division: {
    id: string
    code: string
    value: string
  }
  organization: {
    id: string
    code: string
    name: string
  }
  company: {
    id: string
    code: string
    name: string
  }
  departments: {
    id: string
    code: string
    name: string
  }[]
  type: string
  is_pic?: boolean
}

export interface IAdminRequest {
  employee_number?: string | null
  first_name: string
  last_name?: string
  email: string
  mobile_number: string
  division_id: string
  company_id?: string
  department_ids?: string[]
  organization_pic_id?: string
  is_pic?: boolean
}

export interface IAdminQuery {
  search?: string
  page?: number
  size?: number
  sort?: string
  order?: Order
  statuses?: string[]
  division_ids?: string[]
  department_ids?: string[]
  company_ids?: string[]
}

interface IAdminBulkValue {
  id?: string
  value: string
  is_valid: boolean
}
export interface IAdminBulkRequest {
  first_name: IAdminBulkValue
  last_name: IAdminBulkValue
  email: IAdminBulkValue
  employee_number: IAdminBulkValue
  mobile_number: IAdminBulkValue
  division: IAdminBulkValue
  level: IAdminBulkValue
  company: IAdminBulkValue
  departments: IAdminBulkValue[]
}
